import BuyModal from './buy';

export default {
  BuyModal
};



// WEBPACK FOOTER //
// ./src/components/modals/buyCrypto/index.js